/* eslint-disable camelcase */
(() => {
  const language = window.swinger.config.language;

  const getProductDataFromJSONLD = () => {
    const jsonLdElem = document.querySelector('script[type="application/ld+json"]');

    if (!jsonLdElem) {
      return false;
    }

    try {
      const json = jsonLdElem.textContent.trim();
      if (!json) {
        return false;
      }

      const data = JSON.parse(json);

      return data.find((entry) => entry['@type'] === 'Product');
    } catch (e) {
      return false;
    }
  };

  const trackEcommerce = (eventType, items, value = 0, extra = {}) => {
    let currency = 'EUR';

    try {
      currency = window.swinger.user.getCurrency();
    } catch (e) {
      // noop
    }

    Promise.all(items.map((item) => window.swinger.api.getItemDetails(item.itemNumber)))
      .then((results) => {
        const ecommerce = results
          .map((result) => result[0])
          .reduce((acc, result, index) => {
            if (!result) {
              return acc;
            }

            const transactionType = items[index].transactionType || 'buy';
            let item_category = 'Movie';
            if (result.itemNumber.indexOf('MOV') === 0 && result.itemNumber.indexOf('-') > -1) {
              item_category = 'Scene';
            } else if (result.itemNumber.indexOf('AMA') === 0) {
              item_category = 'Clip';
            }

            const item = {
              item_id: result.itemNumber,
              // eslint-disable-next-line no-nested-ternary
              item_name: result.name[language] ? result.name[language] : (result.name.en ? result.name.en : result.name),
              discount: result.prices.self[transactionType].regularPrice - result.prices.self[transactionType].currentPrice,
              index,
              // eslint-disable-next-line no-nested-ternary
              item_brand: result.studio ? result.studio.name : (result.amateur ? result.amateur.name : undefined),
              item_variant: transactionType,
              item_category,
              price: result.prices.self[transactionType].regularPrice,
            };

            if (result.categories && Array.isArray(result.categories)) {
              result.categories.forEach((entry, index) => {
                item[`item_category${index + 2}`] = entry.name[language];
              });
            }

            if (value === 0) {
              acc.value += result.prices.self[transactionType].currentPrice;
            }
            acc.items.push(item);

            return acc;
          }, {
            currency,
            value,
            items: [],
            ...extra,
          });

        console.log(`Tracked ecommerce event "${eventType}"`);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: eventType,
          ecommerce,
        });
      })
      .catch(console.info);
  };

  window._paq = window._paq || [];
  window.swinger = {
    ...window.swinger,
    tracking: {
      getProductDataFromJSONLD,
      trackEcommerce,
      trackViewItem(itemNumber) {
        trackEcommerce('view_item', [{ itemNumber }]);
      },
      trackAddToCart(itemNumber, transactionType) {
        trackEcommerce('add_to_cart', [{ itemNumber, transactionType }]);
      },
      trackRemoveFromCart(itemNumber) {
        trackEcommerce('remove_from_cart', [{ itemNumber }]);
      },
      trackViewCart(items, value) {
        trackEcommerce('view_cart', items, value);
      },
      trackBeginCheckout(items, value) {
        trackEcommerce('begin_checkout', items, value);
      },
      trackPurchase(items, value, extra) {
        trackEcommerce('purchase', items, value, extra);
      },
      trackAddToWishlist(itemNumber) {
        trackEcommerce('add_to_wishlist', [{ itemNumber }]);
      },
    },
  };

  window.swinger.observer.initialize('script[type="application/ld+json"]', () => {
    const item = getProductDataFromJSONLD();

    if (!item) {
      return;
    }

    window.swinger.tracking.trackViewItem(item.sku);
  }, false);
})();
